import { useEffect, useState } from 'react';
import { checkAppUpdate, openUpdate } from '../appUpdate';

// Popup nhắc cập nhật cho app native. Mặc định nhắc mềm (có "Để sau");
// nếu backend đánh dấu mandatory=true thì CHẶN (bắt cập nhật mới dùng tiếp).
export default function UpdateGate() {
  const [info, setInfo] = useState(null); // { mandatory, versionName, url, notes }
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let alive = true;
    // Kiểm tra khi mở app; và mỗi lần app quay lại foreground (phòng bản mới ra khi đang mở).
    const run = () => checkAppUpdate().then((r) => { if (alive && r) setInfo(r); }).catch(() => {});
    run();
    let remove;
    import('@capacitor/app').then(({ App }) => {
      const h = App.addListener('resume', run);
      remove = () => h.then((x) => x.remove()).catch(() => {});
    }).catch(() => {});
    return () => { alive = false; if (remove) remove(); };
  }, []);

  if (!info || (dismissed && !info.mandatory)) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 3000,
      background: 'rgba(15,20,40,.55)', backdropFilter: 'blur(2px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: `calc(20px + env(safe-area-inset-top)) 20px calc(20px + env(safe-area-inset-bottom))`,
    }}>
      <div style={{
        width: 'min(400px, 100%)', background: 'var(--panel, #fff)', borderRadius: 18,
        padding: '24px 22px', boxShadow: '0 20px 60px rgba(10,20,60,.35)', textAlign: 'center',
      }}>
        <div style={{ fontSize: 44, lineHeight: 1, marginBottom: 6 }}>🎉</div>
        <h3 style={{ margin: '4px 0 2px', fontSize: 20 }}>Đã có bản cập nhật mới</h3>
        {info.versionName && (
          <div className="small muted" style={{ marginBottom: 10 }}>Phiên bản {info.versionName}</div>
        )}
        {info.notes && (
          <div style={{
            fontSize: 14, color: 'var(--text2, #444)', background: 'var(--soft, #f3f5fb)',
            borderRadius: 10, padding: '10px 12px', margin: '6px 0 16px', textAlign: 'left', whiteSpace: 'pre-wrap',
          }}>{info.notes}</div>
        )}
        {!info.notes && <div style={{ height: 12 }} />}

        <button className="btn" style={{ width: '100%', justifyContent: 'center', fontWeight: 700, padding: '12px' }}
          onClick={() => openUpdate(info.url)}>
          ⬇️ Cập nhật ngay
        </button>

        {info.mandatory ? (
          <div className="small muted" style={{ marginTop: 12 }}>
            Bản cập nhật này bắt buộc để tiếp tục sử dụng.
          </div>
        ) : (
          <button className="btn ghost" style={{ width: '100%', justifyContent: 'center', marginTop: 10 }}
            onClick={() => setDismissed(true)}>
            Để sau
          </button>
        )}
      </div>
    </div>
  );
}
